function getCategoryUrlFromPricesAndConversion(action_url, price_min, price_max, price_conversion) {
    var url,
        low_url = false,
        high_url = false,
        individual_price = false;

    if (price_min == '') {
        price_min = '0';
        low_url = true;
    } else if (price_max == '') {
        price_max = '99999999999999';
        high_url = true;
    } else if (price_min == price_max) {
        individual_price = true;
    }

    if (typeof price_max != "undefined" && typeof price_min != "undefined" && price_min != '' && price_max != '') {
        if (price_min != 'over' && price_min != 'under') {
            if (typeof price_conversion != 'undefined' && price_conversion != '' && price_conversion != null) {
                price_min = (price_min / price_conversion).toFixed(2);
            }

            price_min = String(price_min).replace('.00', '').padStart(5, '0').replace('.', '_');
        }

        if (price_max != '99999999999999' && (typeof price_conversion != 'undefined' && price_conversion != '' && price_conversion != null)) {
            price_max = (price_max / price_conversion).toFixed(2);
        }

        price_max = String(price_max).replace('.00', '').padStart(5, '0').replace('.', '_');

        if (low_url) {
            url = action_url + '/under-' + price_max;
        } else if (high_url) {
            url = action_url + '/over-' + price_min;
        } else if (individual_price) {
            url = action_url + '/' + price_min;
        } else {
            url = action_url + '/' + price_min + '-' + price_max;
        }

    } else {
        url = action_url;
    }

    return url;
}

export {getCategoryUrlFromPricesAndConversion}